import httpInstance from '../httpInstance';

const getNationalHolidaysService = async () => {
  let res;
  const endpoint = '/back-office/v1/holidays/all';
  await httpInstance.get(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default getNationalHolidaysService;
